import { Divider, Grid } from "@mui/material";
import { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import InviteNewGmtUserForm from "../../components/UI/Forms/Wizard Forms/AddForms/InviteNewGmtUserForm";
import PageHeader from "../../components/UI/Headers/PageHeader/PageHeader";
import CustomTabs from "../../components/UI/Tabs/CustomTabs/CustomTabs";
import { TabItemEntity } from "../../entities/UIEntities/TabItem";
import { ROLES_HIERARCHY, TABLES } from "../../enums/Enums";
import useGmtService, { fetchGmtUsersData } from "../../hooks/useGmtService";
import { commonActions } from "../../redux/reducers/CommonReducer";
import { userActions } from "../../redux/reducers/UserReducer";
import store from "../../redux/Store";
import Icons from "../../resources/icons/Icons";
import Strings from "../../resources/Strings";
import classes from "../Parkers/ParkersPage.module.css";
import GmtInfo from "../UserInfo/SideWindowInfo/GmtInfo";
import AddChargeAccountForm from "../../components/UI/Forms/Wizard Forms/AddForms/AddChargeAccountForm";
import { getSitesUnderSelectedScope } from "../../utils/UsersUtils";

const AdminPage = () => {
  const allScopes = useSelector((state) => state.user?.allScopes);
  const sites = useSelector((state) => state.user?.sites);
  const selectedScope = useSelector((state) => state.user?.selectedScope);
  const showChargeAccountTab = getSitesUnderSelectedScope(sites, allScopes, selectedScope)?.some(site => site?.isAllowedForTransients); 
  const currentGmtUsers = useSelector((state) => state.user.currentGmtUsers);
  const currentChargeAccounts = useSelector((state) => state.user.currentChargeAccounts);
  const gmtUser = useSelector((state) => state.user.gmtUser);
  const [tableName, setTableName] = useState(Strings.TABS_NAMES.GMT_USERS_MANAGMENT);
  let tabs = [];
  const showUserInfoWindow = useSelector((state) => {
    return state.user?.showUserInfoWindow;
  });

  const [selectionModel, setSelectionModel] = useState(null);
  const { getGmtDataTable, getChargeAccountsDataTable } = useGmtService();
  const isFirstTimeLoading = useSelector((state) => state.common.isFirstTimeLoading);  

  useEffect(() => {    
    fetchGmtUsersData(selectedScope.id, isFirstTimeLoading);
  }, [selectedScope.id]);

  const onRowClick = (selectionModel) => {
    const isNotEmptyModel = Object.keys(selectionModel).length !== 0;
    setSelectionModel(selectionModel);
    if (isNotEmptyModel) {
      store.dispatch(userActions.setShowUserInfoWindow(true));
    }
  };

  let gmtUsersTab = new TabItemEntity(
    Strings.TABS_NAMES.GMT_USERS_MANAGMENT,
    TABLES.GMT,
    getGmtDataTable(onRowClick)
  );

  let chargeAccountsTab = new TabItemEntity(
    Strings.TABS_NAMES.CHARGE_ACCOUNTS,
    TABLES.CHARGE_ACCOUNTS,
    getChargeAccountsDataTable(onRowClick)
  );

  useEffect(() => {
    if (!selectionModel) return;
    
    let updatedSelectionModel;
    if (tableName === Strings.TABS_NAMES.GMT_USERS_MANAGMENT) {
      updatedSelectionModel = currentGmtUsers.find(gmtUser => gmtUser?.id === selectionModel?.id);
    }
    else {
      updatedSelectionModel = currentChargeAccounts.find(acc => acc?.utronUser?.id === selectionModel?.utronUser?.id);
    }

    if (updatedSelectionModel) {
      setSelectionModel(updatedSelectionModel)
    }

  },[currentGmtUsers, currentChargeAccounts, selectionModel, tableName]);

  useEffect(() => {
    if (!showChargeAccountTab) {
      setTableName(Strings.TABS_NAMES.GMT_USERS_MANAGMENT);
    }
  }, [selectedScope]);

  tabs = showChargeAccountTab ? [gmtUsersTab, chargeAccountsTab] : [gmtUsersTab];

  const handleTabChanged = (tableName) => {
    setTableName(tableName);
  };

  const handleCloseEvent = () => {
    store.dispatch(userActions.setShowUserInfoWindow(false));
  };

  const handleModalOpen = () => {
    if (tableName === Strings.TABS_NAMES.GMT_USERS_MANAGMENT) {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <InviteNewGmtUserForm userData={selectionModel} /> })
      );
    }
    else {
      store.dispatch(
        commonActions.setSideModal({ modalContent: <AddChargeAccountForm userData={selectionModel} isEditMode={false}/> })
      );
    }
    
  };

  return (
    <div className={classes.parkersPage}>
      <Grid container spacing={4} className={classes.parkersContainer}>
        <Grid xs={12} item className={classes.item}>
          <PageHeader
            icon={Icons.GMT_HEADER}
            pageTitle={Strings.TITLES.ADMIN_PAGE}
            buttonText={tableName === Strings.TABS_NAMES.GMT_USERS_MANAGMENT ? Strings.INVITE_GMT_USER : Strings.CHARGE_ACCOUNT}
            validRole={
              gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR
            }
            handleModalOpen={handleModalOpen}
          />
          {tabs && (
            <CustomTabs
              initialTab={Strings.TABS_NAMES.GMT_USERS_MANAGMENT}
              tabs={tabs}
              onTabChange={handleTabChanged /*handleCloseEvent*/}
            ></CustomTabs>
          )}
        </Grid>
        {showUserInfoWindow && selectionModel && (
          <Divider orientation="vertical" flexItem></Divider>
        )}
        {showUserInfoWindow && selectionModel && (
          <Grid xs={5} item className={classes.item}>
            <GmtInfo
              {...selectionModel}
              handleCloseEvent={handleCloseEvent}
              validRole={
                gmtUser?.role?.hierarchy <= ROLES_HIERARCHY.ADMINISTRATOR
              }
            ></GmtInfo>
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default AdminPage;
